import React from "react";
import {
  Block,
  Block1,
  BlockText,
  Upload,
  Ad,
  SettingIcon,
  Container,
  LogoOgilvy,
  RowClass,
} from "../../style/Home";
import { CustomLinkSign } from "../../style/Login";

import { makeStyles } from "@material-ui/core/styles";
import { withStyles } from "@material-ui/styles";
import axios from "axios";
import "primeicons/primeicons.css";
import { FileUpload } from "primereact/fileupload";
import "primereact/resources/primereact.css";
import "primereact/resources/primereact.min.css";
import "primereact/resources/themes/saga-blue/theme.css";
import { Toast } from "primereact/toast";
import PropTypes from "prop-types";
import { serverUrl } from "../../appconst";
import SettingLogo from "../../assets/setting.svg";
import PharmacyIcon from "../../assets/Pmc/PharmacyIcon.png";
import SocialIcon from "../../assets/Pmc/SocialIcon.png";
import OgilivyLogo from "../../assets/Pmc/ogilvy.svg";
import Setting from "../../assets/Pmc/setting.svg";
import { verifyAuth } from "../../authverify";
import EhrLogin from "../EhrLogin/EhrLogin";
import { Logo1 } from "../logo/Logo";
import "./primeUpload.css";

import CustomizePopup from "./CustomizePopup";
import { Grid } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  icon: {
    cursor: "pointer",
  },
}));

class OgilyHome extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      selectedFile: null,
      imageurl: "",
      token: JSON.parse(window.sessionStorage.getItem("usersession")),
      open: false,
    };
    if (!verifyAuth()) {
      this.props.history.push({
        pathname: "/",
      });
    }

    this.setSelectedFile = this.setSelectedFile.bind(this);
    this.onClickHandler = this.onClickHandler.bind(this);
    this.updatePath = this.updatePath.bind(this);

    if (this.state.token) this.state.imageurl = this.state.token.logoloc;
  }

  setSelectedFile = (e) => {
    this.state.selectedFile = e.files[0];
  };

  pmclickHandler = (name) => {
    console.log("clickedd", name);
    this.props.history.push({ pathname: '/Pmc/dashboard', })
  }



  updatePath = () => {
    fetch(serverUrl + "/api/user/updatepath", {
      method: "POST",
      headers: {
        "x-access-token": this.state.token.accessToken,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ path: this.state.imageurl }),
    })
      .then((response) => response.json())
      .then((result) => {
        console.log("Success:", result);
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };

  onClickHandler = () => {
    const headers = {
      "x-access-token": this.state.token.accessToken,
    };
    if (this.state.selectedFile) {
      // let token = JSON.parse(window.sessionStorage.getItem("usersession"))
      const dataf = new FormData();
      dataf.append("userId", this.state.token.id);
      dataf.append("file", this.state.selectedFile);

      axios({
        method: "post",
        url: serverUrl + "/api/user/logoUpload",
        data: dataf,

        headers: {
          "Content-Type": "multipart/form-data",
          authorization: this.state.token.accessToken,
          "x-access-token": this.state.token.accessToken,
        },
      })
        .then((res) => {
          // then print response status
          //var data = JSON.parse(window.sessionStorage.getItem("usersession"));
          this.state.token.logoloc = res.data.location;
          window.sessionStorage.setItem(
            "usersession",
            JSON.stringify(this.state.token)
          );
          this.state.imageurl = res.data.location;
          this.updatePath();
          this.forceUpdate();
          this.toast.show({
            severity: "info",
            summary: "Success",
            detail: "File Uploaded",
          });
        })
        .catch((error) => { });
    }
  };

  createImage = () => {
    const chooseOptions = {
      icon: "pi-cog",
      className: ` p-button-rounded  p-button-icon-only  p-button-text  p-button-secondary p-0`,
    };
    if (this.state.imageurl) {
      return (
        <Upload>
          <img src={this.state.imageurl} style={{ width: "90px" }} alt="logo" />
          <form style={{ margin: "-7px" }}>
            <FileUpload
              chooseLabel=" "
              style={{ marginLeft: "65px", size: "30px" }}
              chooseOptions={chooseOptions}
              mode="basic"
              name="file"
              onSelect={this.setSelectedFile}
              url="https://primefaces.org/primereact/showcase/upload.php"
              accept="image/*"
              maxFileSize={1000000}
              onUpload={this.onClickHandler}
            />
          </form>
        </Upload>
      );
    } else {
      return (
        <>
        </>
      );
    }
  };

  createSignUpLink = () => {
    if (this.state.token.role === "Admin") {
      return (
        <div>
          <CustomLinkSign to="/createuser"> Admin Section </CustomLinkSign>
        </div>
      );
    } else {
      return "";
    }
  };


  handleOpenPopup = () => {
    this.setState({ open: true });
  };

  handleClosePopup = () => {
    console.log("testing")
    this.setState({ open: false });
  };
  render() {
    const fragment = this.createImage();
    const signUpLink = this.createSignUpLink();
    return (
      <div>
        <div className="conatiner-header">
          <Grid container spacing={0}>
            <Grid item xs={8} className="welcomeLogo">
              <Logo1 />
            </Grid>
            <Grid item xs={4} className="text-right">
              {/* <LogoOgilvy src={OgilivyLogo} alt="Ogilvy logo" />  */}
              <SettingIcon className="welcomeSetting" src={Setting} alt="setting" onClick={this.handleOpenPopup} />
            </Grid>
          </Grid>
        </div>
        <React.Fragment>{fragment}</React.Fragment>
        {signUpLink}

        <Container>
          <Block>
            <EhrLogin />
            <BlockText
              color="#B263DE"
              top="215px"
              left="50px"
              style={{ fontSize: "20px", textAlign: "center", marginTop: "20px", }}
            >
              Point of Care
            </BlockText>
            <BlockText
              color="grey"
              style={{ fontSize: "20.67px", fontWeight: "700", textAlign: "center" }}
            >
              Demo
            </BlockText>
            {/* <BlockText
              color="grey"
              style={{
                fontSize: "20.67px",
                fontWeight: "500",
                textAlign: "center",
              }}
            >
              This take you through the<br /> HCP journey within their<br /> practise
              workflow.
            </BlockText> */}
            <BlockText
              color="grey"
              top="400px"
              left="20px"
              style={{
                fontSize: "12px",
                fontWeight: "500",
                textAlign: "center",
              }}>
            </BlockText>
          </Block>

          <Block1>
            {/* <RiHeartPulseLine size="150" color="lightgrey"/> */}
            <img
              src={SocialIcon}
              alt="SocialIcon"
              style={{
                borderRadius: "20px",
                width: "210px",
                marginTop: "-5px",
                marginLeft: "-5px",
                padding: "38px 20px",
                border: "1px solid"
              }}
            />
            <BlockText
              color="lightgrey"
              style={{ fontSize: "20px", textAlign: "center", marginTop: "20px" }}
            >
              Social Display
            </BlockText>
            <BlockText
              color="lightgrey"
              style={{ fontSize: "20.67px", fontWeight: "700", textAlign: "center" }}
            >
              Demo
            </BlockText>
            {/* <BlockText
              color="grey"
              style={{
                fontSize: "20.67px",
                fontWeight: "500",
                textAlign: "center",
              }}
            >
              This take you through the<br /> HCP journey within their<br /> practise
              workflow.
            </BlockText> */}
          </Block1>

          {/* pharmacy management system */}
          <Block>
            {/* <EhrLogin /> */}
            <img
              src={PharmacyIcon}
              alt="PharmacyIcon"
              style={{
                onjectFit: "contain",
                width: "210px",
                borderRadius: "20px",
                border: "0px solid transparent",
                padding: "0px",
              }}
              onClick={() => this.pmclickHandler("clicked on pmc button")}
            />
            <BlockText
              color="#4678ED"
              style={{ fontSize: "20px", textAlign: "center", marginTop: "20px" }}
            >
              Pharmacy Management system
            </BlockText>
            <BlockText
              color="grey"
              style={{ fontSize: "20.67px", fontWeight: "700", textAlign: "center" }}
            >
              Demo
            </BlockText>
            {/* <BlockText
              color="grey"
              style={{
                fontSize: "20.67px",
                fontWeight: "500",
                textAlign: "center",
              }}
            >
              This take you through the<br /> HCP journey within their<br /> practise
              workflow.
            </BlockText> */}
          </Block>


        </Container>


        <Toast
          ref={(el) => {
            this.toast = el;
          }}
        ></Toast>
        {this.state.open && <CustomizePopup open={this.state.open} onClose={this.handleClosePopup} />}
      </div>
    );
  }
}

OgilyHome.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(useStyles)(OgilyHome);
